<!-- TODO:AB AXB-696 HIDE THE USER SEGMENTS -->
<!-- TODO:MK AXB-884 CXB to UXB MERGE DISPLAY THE USER SEGMENTS -->
<ng-container *ngIf="currentPageActions$ | async as currentPageActions">
  <div *ngIf="currentPageActions.isUserSegmentEnabled" class="row d-flex align-items-center">
    <label class="col-6 required">User segments</label>
    <span class="col">Anonymous</span>
  </div>
</ng-container>
